import { gql } from '@apollo/client';

// ================== 인증 관련 ==================
export const REGISTER_MUTATION = gql`
  mutation Register($input: RegisterInput!) {
    register(input: $input) {
      token
      user {
        id
        email
        name
        phone
        company
        role
        createdAt
      }
    }
  }
`;

export const LOGIN_MUTATION = gql`
  mutation Login($input: LoginInput!) {
    login(input: $input) {
      token
      user {
        id
        email
        name
        phone
        company
        role
        lastLoginAt
      }
    }
  }
`;

export const ME_QUERY = gql`
  query Me {
    me {
      id
      email
      name
      phone
      company
      ceoName
      zipCode
      address
      addressDetail
      businessNumber
      department
      mobile
      fax
      role
      isActive
      createdAt
      updatedAt
      lastLoginAt
      cartItems {
        id
        quantity
        product {
          id
          name
          price
          images
        }
      }
    }
  }
`;

export const UPDATE_PROFILE_MUTATION = gql`
  mutation UpdateProfile($input: UserUpdateInput!) {
    updateProfile(input: $input) {
      id
      name
      phone
      company
      ceoName
      zipCode
      address
      addressDetail
      businessNumber
      department
      mobile
      fax
      updatedAt
    }
  }
`;

export const UPDATE_EMAIL_MUTATION = gql`
  mutation UpdateEmail($input: EmailUpdateInput!) {
    updateEmail(input: $input) {
      id
      email
      updatedAt
    }
  }
`;

export const CHANGE_PASSWORD_MUTATION = gql`
  mutation ChangePassword($oldPassword: String!, $newPassword: String!) {
    changePassword(oldPassword: $oldPassword, newPassword: $newPassword)
  }
`;

// ================== 관리자 관련 ==================
export const GET_ALL_USERS = gql`
  query GetAllUsers {
    users {
      id
      email
      name
      phone
      mobile
      company
      ceoName
      zipCode
      address
      addressDetail
      businessNumber
      department
      fax
      role
      isActive
      blockedAt
      level
      createdAt
      lastLoginAt
      quotations {
        id
      }
    }
  }
`;

export const GET_USER_BY_ID = gql`
  query GetUserById($id: Int!) {
    user(id: $id) {
      id
      email
      name
      phone
      mobile
      company
      ceoName
      zipCode
      address
      addressDetail
      businessNumber
      department
      fax
      role
      level
      isActive
      createdAt
      lastLoginAt
      deliveryAddresses {
        id
        name
        recipient
        phone
        zipCode
        address
        addressDetail
        isDefault
        createdAt
      }
      quotations {
        id
      }
    }
  }
`;

// 월별 가입 통계 조회
export const GET_MONTHLY_SIGNUP_STATS = gql`
  query GetMonthlySignupStats($year: Int!) {
    monthlySignupStats(year: $year) {
      month
      totalSignups
      percentage
      aGradeCount
      bGradeCount
      cGradeCount
      dGradeCount
    }
  }
`;

// 월별 접속 통계 조회
export const GET_MONTHLY_CONNECTION_STATS = gql`
  query GetMonthlyConnectionStats($year: Int!) {
    monthlyConnectionStats(year: $year) {
      month
      totalConnections
      percentage
      aGradeCount
      bGradeCount
      cGradeCount
      dGradeCount
    }
  }
`;

// 현재 접속자 수 조회
export const GET_CURRENT_ACTIVE_USERS = gql`
  query GetCurrentActiveUsers {
    currentActiveUsers
  }
`;

// 탈퇴한 회원 목록 조회
export const GET_WITHDRAWN_USERS = gql`
  query GetWithdrawnUsers($searchTerm: String, $searchType: String) {
    withdrawnUsers(searchTerm: $searchTerm, searchType: $searchType) {
      id
      email
      name
      phone
      mobile
      company
      ceoName
      department
      role
      isActive
      blockedAt
      level
      createdAt
      updatedAt
      lastLoginAt
      loginCount
      quotationCount
    }
  }
`;

// 사용자 차단 뮤테이션
export const BLOCK_USER_MUTATION = gql`
  mutation BlockUser($userId: Int!) {
    blockUser(userId: $userId) {
      id
      isActive
      blockedAt
    }
  }
`;

// 사용자 차단 해제 뮤테이션
export const UNBLOCK_USER_MUTATION = gql`
  mutation UnblockUser($userId: Int!) {
    unblockUser(userId: $userId) {
      id
      isActive
      blockedAt
    }
  }
`;

// 회원 탈퇴 뮤테이션
export const WITHDRAW_USER_MUTATION = gql`
  mutation WithdrawUser($userId: Int!) {
    withdrawUser(userId: $userId) {
      id
      isActive
      blockedAt
    }
  }
`;

// 사용자 등급 변경 뮤테이션
export const UPDATE_USER_LEVEL_MUTATION = gql`
  mutation UpdateUserLevel($userId: Int!, $level: UserLevel!) {
    updateUserLevel(userId: $userId, level: $level) {
      id
      level
    }
  }
`;

// 아이디 찾기 뮤테이션
export const FIND_USER_ID_MUTATION = gql`
  mutation FindUserId($name: String!, $phone: String!) {
    findUserId(name: $name, phone: $phone) {
      success
      message
    }
  }
`;

// 비밀번호 재설정 뮤테이션
export const RESET_PASSWORD_MUTATION = gql`
  mutation ResetPassword($email: String!, $name: String!) {
    resetPassword(email: $email, name: $name) {
      success
      message
    }
  }
`;

// 사용자 정보 업데이트 뮤테이션
export const UPDATE_USER_MUTATION = gql`
  mutation UpdateUser($id: Int!, $input: UpdateUserInput!) {
    updateUser(id: $id, input: $input) {
      id
      email
      name
      company
      ceoName
      zipCode
      address
      addressDetail
      businessNumber
      phone
      mobile
      department
      fax
      level
      isActive
      createdAt
      updatedAt
    }
  }
`; 